<ng-container *transloco="let t">
  <div class="account-list-container">
    <p>{{ t('oreg_account_account_coordinator') }}</p>
    <h2 class="heading-size-4">{{ t('oreg_account_select_account') }}</h2>
    <div class="account-list-body">
      <ul>
        @for (account of accountList(); track $index) {
          <li>
            <button (click)="selectedAccount = account">
              <div class="account-info">
                <span class="country">{{
                  account.country | translatedCountry: 'sv'
                }}</span>
                @if (account.number) {
                  <span
                    >{{
                      account.type === 'PlusGiro'
                        ? t('oreg_account_PlusGiro_number')
                        : account.type === 'BankGiro'
                          ? t('oreg_account_bank_transfer_number')
                          : t('oreg_account_account_number')
                    }}: {{ account.number }}</span
                  >
                }
                @if (account.iban) {
                  <span>{{ t('oreg_account_iban') }}: {{ account.iban }}</span>
                }
                @if (account.bsbCode) {
                  <span
                    >{{ t('oreg_account_bsb_code') }}:
                    {{ account.bsbCode }}</span
                  >
                }
                @if (account.routing) {
                  <span
                    >{{ t('oreg_account_routing_number') }}:
                    {{ account.routing }}</span
                  >
                }
                @if (account.fw) {
                  <span>{{ t('oreg_account_fw') }}: {{ account.fw }}</span>
                }
                @if (account.swift) {
                  <span
                    >{{ t('oreg_account_swift') }}: {{ account.swift }}</span
                  >
                }
              </div>
              <div>
                @if (account.id === selectedAccount?.id) {
                  <lib-icon name="check"></lib-icon>
                }
              </div>
            </button>
          </li>
        }
      </ul>
    </div>
    <div class="button-container">
      <button
        vinnova-button-secondary
        [attr.aria-label]="t('oreg_account_cancel')"
        (click)="cancel.emit()"
      >
        {{ t('oreg_account_cancel') }}
      </button>
      <button
        vinnova-button-secondary
        [attr.aria-label]="t('oreg_account_add_account')"
        (click)="createAccount.emit()"
      >
        {{ t('oreg_account_add_account') }}
      </button>
      <button
        vinnova-button-primary
        [disabled]="!selectedAccount"
        [attr.aria-label]="t('oreg_account_select')"
        (click)="selectAccount.emit(selectedAccount)"
      >
        {{ t('oreg_account_select') }}
      </button>
    </div>
  </div>
</ng-container>
